import React, { useState } from 'react';

const PREDEFINED_PLATFORMS = [
  { id: 'ios', name: 'iOS', emoji: '📱', class: 'ios' },
  { id: 'android', name: 'Android', emoji: '🤖', class: 'android' },
  { id: 'web', name: 'Web', emoji: '🌐', class: 'web' }
];

function PlatformSelector({ platforms, onChange }) {
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customPlatform, setCustomPlatform] = useState('');

  const addPlatform = (platform) => {
    if (!platforms.includes(platform)) {
      onChange([...platforms, platform]);
    }
  };

  const removePlatform = (platform) => {
    onChange(platforms.filter(p => p !== platform));
  };

  const addCustomPlatform = () => {
    if (customPlatform.trim() && !platforms.includes(customPlatform.trim())) {
      onChange([...platforms, customPlatform.trim()]);
      setCustomPlatform('');
      setShowCustomInput(false);
    }
  };

  const getPlatformInfo = (platform) => {
    const predefined = PREDEFINED_PLATFORMS.find(p => p.name === platform);
    return predefined || { id: 'other', name: platform, emoji: '⚙️', class: 'other' };
  };

  return (
    <div>
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
          Available Platforms
        </label>
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          {PREDEFINED_PLATFORMS.map(platform => (
            <button
              key={platform.id}
              type="button"
              className={`platform-pill ${platform.class}`}
              onClick={() => addPlatform(platform.name)}
              disabled={platforms.includes(platform.name)}
              style={{ opacity: platforms.includes(platform.name) ? 0.5 : 1 }}
            >
              {platform.emoji} {platform.name}
            </button>
          ))}
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowCustomInput(true)}
            style={{ padding: '0.25rem 0.75rem', fontSize: '0.875rem' }}
          >
            ➕ Other
          </button>
        </div>
      </div>

      {showCustomInput && (
        <div className="form-group">
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <input
              type="text"
              className="form-control"
              value={customPlatform}
              onChange={(e) => setCustomPlatform(e.target.value)}
              placeholder="Enter custom platform name"
              onKeyPress={(e) => e.key === 'Enter' && addCustomPlatform()}
            />
            <button type="button" className="btn btn-primary" onClick={addCustomPlatform}>
              Add
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => {
              setShowCustomInput(false);
              setCustomPlatform('');
            }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      <div>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
          Selected Platforms
        </label>
        <div className="platform-pills">
          {platforms.map(platform => {
            const info = getPlatformInfo(platform);
            return (
              <div key={platform} className={`platform-pill ${info.class}`}>
                {info.emoji} {platform}
                <span 
                  className="remove" 
                  onClick={() => removePlatform(platform)}
                  title="Remove platform"
                >
                  ✕
                </span>
              </div>
            );
          })}
          {platforms.length === 0 && (
            <div style={{ color: '#6b7280', fontStyle: 'italic' }}>
              No platforms selected
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PlatformSelector; 